import { Pipe, PipeTransform } from '@angular/core';
import { Pronunciation } from 'app/modules/admin/services/pronunciation.service';

@Pipe({
  name: 'pronunciationFilter'
})
export class PronunciationFilterPipe implements PipeTransform {
 
  transform(entities: any[], searchName: string, searchIsActive: boolean): any[] {

    console.log(searchIsActive);

    if (searchName === "" || searchName === undefined || searchName.length < 2) {  
      if (searchIsActive == null) {
        return entities; 
      }
    }

    var results = this.filterByName(entities, searchName);

    if (searchIsActive != null) {
      results = results.filter((s: Pronunciation) => {
        return (s.IsActive == searchIsActive);
      })
    }

    return results; 
 
   }
     
   private filterByName(entities: any[], searchTerm: string) {
      
    if (searchTerm === undefined) {
      return entities;
    }

    searchTerm = searchTerm.toLowerCase();

    console.log(entities);
    var results = entities.filter((entity) => {
      var matches = entity.AvailableSearchTerms.filter((s) => {
        if (s == null) return null;
        return (s.toLowerCase().indexOf(searchTerm) > -1)
      });

      return matches.length > 0;
    });

    return results;
   }
}
